/* INTERVENTION SEND */

/* INTERVENTIONS MEDIA */
export const UPDATE_INTERVENTION_MEDIA_ORDER_REQUEST = 'UPDATE_INTERVENTION_MEDIA_ORDER_REQUEST';
export const UPDATE_INTERVENTION_MEDIA_ORDER_SUCCESS = 'UPDATE_INTERVENTION_MEDIA_ORDER_SUCCESS';
export const UPDATE_INTERVENTION_MEDIA_ORDER_FAILURE = 'UPDATE_INTERVENTION_MEDIA_ORDER_FAILURE';

/* DEALERS */
export const FETCH_DEALERS_REQUEST = 'FETCH_DEALERS_REQUEST';
export const FETCH_DEALERS_BY_REDUCER_REQUEST = 'FETCH_DEALERS_BY_REDUCER_REQUEST';
export const FETCH_DEALERS_SUCCESS = 'FETCH_DEALERS_SUCCESS';
export const FETCH_DEALERS_FAILURE = 'FETCH_DEALERS_FAILURE';
export const FETCH_DEALER_REQUEST = 'FETCH_DEALER_REQUEST';
export const FETCH_DEALER_SUCCESS = 'FETCH_DEALER_SUCCESS';
export const FETCH_DEALER_FAILURE = 'FETCH_DEALER_FAILURE';
export const FETCH_DEALERS_SELECT_REQUEST = 'FETCH_DEALERS_SELECT_REQUEST';
export const FETCH_DEALERS_SELECT_SUCCESS = 'FETCH_DEALERS_SELECT_SUCCESS';
export const FETCH_DEALERS_SELECT_FAILURE = 'FETCH_DEALERS_SELECT_FAILURE';
export const SELECT_DEALER = 'SELECT_DEALER';
export const CREATE_DEALER_REQUEST = 'CREATE_DEALER_REQUEST';
export const CREATE_DEALER_SUCCESS = 'CREATE_DEALER_SUCCESS';
export const CREATE_DEALER_FAILURE = 'CREATE_DEALER_FAILURE';
export const UPDATE_DEALER_REQUEST = 'UPDATE_DEALER_REQUEST';
export const UPDATE_DEALER_SUCCESS = 'UPDATE_DEALER_SUCCESS';
export const UPDATE_DEALER_FAILURE = 'UPDATE_DEALER_FAILURE';
export const CHANGE_DEALER_STATUS_REQUEST = 'CHANGE_DEALER_STATUS_REQUEST';
export const CHANGE_DEALER_STATUS_SUCCESS = 'CHANGE_DEALER_STATUS_SUCCESS';
export const CHANGE_DEALER_STATUS_FAILURE = 'CHANGE_DEALER_STATUS_FAILURE';

export const DEALER_NAME_VALIDATING = 'DEALER_NAME_VALIDATING';
export const DEALER_NAME_CHECK_REQUEST = 'DEALER_NAME_CHECK_REQUEST';
export const DEALER_NAME_CHECK_SUCCESS = 'DEALER_NAME_CHECK_SUCCESS';
export const DEALER_NAME_CHECK_FAILURE = 'DEALER_NAME_CHECK_FAILURE';
/* BRANDING TEMPLATES */
export const FETCH_BRANDING_TEMPLATES_REQUEST = 'FETCH_BRANDING_TEMPLATES_REQUEST';
export const FETCH_BRANDING_TEMPLATES_SUCCESS = 'FETCH_BRANDING_TEMPLATES_SUCCESS';
export const FETCH_BRANDING_TEMPLATES_FAILURE = 'FETCH_BRANDING_TEMPLATES_FAILURE';

/* EXTENSIONS */
export const FETCH_EXTENSIONS_REQUEST = 'FETCH_EXTENSIONS_REQUEST';
export const FETCH_EXTENSIONS_SUCCESS = 'FETCH_EXTENSIONS_SUCCESS';
export const FETCH_EXTENSIONS_FAILURE = 'FETCH_EXTENSIONS_FAILURE';

/* CUSTOMERS */
export const FETCH_CUSTOMERS_REQUEST = 'FETCH_CUSTOMERS_REQUEST';
export const FETCH_CUSTOMERS_SUCCESS = 'FETCH_CUSTOMERS_SUCCESS';
export const FETCH_CUSTOMERS_FAILURE = 'FETCH_CUSTOMERS_FAILURE';
export const FETCH_CUSTOMERS_SELECT_REQUEST = 'FETCH_CUSTOMERS_SELECT_REQUEST';
export const FETCH_CUSTOMERS_SELECT_SUCCESS = 'FETCH_CUSTOMERS_SELECT_SUCCESS';
export const FETCH_CUSTOMERS_SELECT_FAILURE = 'FETCH_CUSTOMERS_SELECT_FAILURE';

export const CLEAN_CUSTOMERS_SELECT = 'CLEAN_CUSTOMERS_SELECT';

export const FETCH_CUSTOMER_REQUEST = 'FETCH_CUSTOMER_REQUEST';
export const FETCH_CUSTOMER_SUCCESS = 'FETCH_CUSTOMER_SUCCESS';
export const FETCH_CUSTOMER_FAILURE = 'FETCH_CUSTOMER_FAILURE';
export const FETCH_CUSTOMER_SELECT_REQUEST = 'FETCH_CUSTOMER_SELECT_REQUEST';
export const FETCH_CUSTOMER_SELECT_SUCCESS = 'FETCH_CUSTOMER_SELECT_SUCCESS';
export const FETCH_CUSTOMER_SELECT_FAILURE = 'FETCH_CUSTOMER_SELECT_FAILURE';
export const EXPORT_CUSTOMER_REQUEST = 'CUSTOMER/EXPORT/REQUEST';
export const EXPORT_CUSTOMER_SUCCESS = 'CUSTOMER/EXPORT/SUCCESS';
export const EXPORT_CUSTOMER_FAILURE = 'CUSTOMER/EXPORT/FAILURE';

export const CREATE_CUSTOMER_REQUEST = 'CREATE_CUSTOMER_REQUEST';
export const CREATE_CUSTOMER_SUCCESS = 'CREATE_CUSTOMER_SUCCESS';
export const CREATE_CUSTOMER_FAILURE = 'CREATE_CUSTOMER_FAILURE';

export const UPDATE_CUSTOMER_REQUEST = 'UPDATE_CUSTOMER_REQUEST';
export const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMER_FAILURE = 'UPDATE_CUSTOMER_FAILURE';

export const DELETE_CUSTOMER_REQUEST = 'CUSTOMER/DELETE_REQUEST';
export const DELETE_CUSTOMER_SUCCESS = 'CUSTOMER/DELETE_SUCCESS';
export const DELETE_CUSTOMER_FAILURE = 'CUSTOMER/DELETE_FAILURE';

export const CLEAN_CUSTOMERS_REQUEST = 'CLEAN_CUSTOMERS_REQUEST';

export const DISPLAY_CREATION_MODAL = 'DISPLAY_CREATION_MODAL';
export const HIDE_CREATION_MODAL = 'HIDE_CREATION_MODAL';

/* USERS */
export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const INIT_USERS_DASHBOARD = 'USERS/INIT_DASHBOARD';
export const SET_USERS_FILTER = 'SET_USERS_FILTER';
export const REMOVE_USER_FILTER = 'USER/DASHBOARD/REMOVE_USER_FILTER';
export const RESET_USER_FILTER = 'USER/DASHBOARD/RESET_USER_FILTER';
export const PERSISTED_USER_ACTION_TYPES = [SET_USERS_FILTER, REMOVE_USER_FILTER, RESET_USER_FILTER];

export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

export const USER_EXISTS_REQUEST = 'USER_EXISTS_REQUEST';
export const USER_EXISTS_FAILURE = 'USER_EXISTS_FAILURE';
export const USER_EXISTS_SUCCESS = 'USER_EXISTS_SUCCESS';
export const CLEAN_USER_EXISTS_REQUEST = 'CLEAN_USER_EXISTS_REQUEST';

export const FETCH_ASSIGNED_USERS = 'USERS/ASSIGNED/FETCH_REQUEST';
export const FETCH_ASSIGNED_USERS_SUCCESS = 'USERS/ASSIGNED/FETCH_SUCCESS';
export const FETCH_ASSIGNED_USERS_FAILURE = 'USERS/ASSIGNED/FETCH_FAILURE';
export const CLEAN_ASSIGNED_USERS = 'USERS/ASSIGNED/CLEAN_REQUEST';
export const FETCH_ASSIGNED_USERS_NEXT_PAGE = 'USERS/ASSIGNED/FETCH_NEXT_PAGE_REQUEST';

// LANG
export const FETCH_LANGUAGES_REQUEST = 'FETCH_LANGUAGES_REQUEST';
export const FETCH_LANGUAGES_SUCCESS = 'FETCH_LANGUAGES_SUCCESS';
export const FETCH_LANGUAGES_FAILURE = 'FETCH_LANGUAGES_FAILURE';

export const USER_LOGOUT_CLEAR = 'USER_LOGOUT_CLEAR';

export const FETCH_LATEST_REFRESH_REQUEST = 'FETCH_LATEST_REFRESH_REQUEST';
export const FETCH_LATEST_REFRESH_FAILURE = 'FETCH_LATEST_REFRESH_FAILURE';
export const FETCH_LATEST_REFRESH_SUCCESS = 'FETCH_LATEST_REFRESH_SUCCESS';

/* DEALER_CONFIG */
export const DEPOSIT_PREVIEW = 'DEPOSIT_PREVIEW_REQUEST';
export const DEPOSIT_PREVIEW_SUCCESS = 'DEPOSIT_PREVIEW_SUCCESS';
export const DEPOSIT_PREVIEW_FAILURE = 'DEPOSIT_PREVIEW_FAILURE';
export const PICKUP_PREVIEW = 'PICKUP_PREVIEW_REQUEST';
export const PICKUP_PREVIEW_SUCCESS = 'PICKUP_PREVIEW_SUCCESS';
export const PICKUP_PREVIEW_FAILURE = 'PICKUP_PREVIEW_FAILURE';

/* PACKS */
export const FETCH_FLEETBACK_PACK_REQUEST = 'FETCH_FLEETBACK_PACK_REQUEST';
export const FETCH_FLEETBACK_PACK_SUCCESS = 'FETCH_FLEETBACK_PACK_SUCCESS';
export const FETCH_FLEETBACK_PACK_FAILURE = 'FETCH_FLEETBACK_PACK_FAILURE';

/* DEALER STATISTICS */
export const FETCH_STATISTICS_DEALERS_REQUEST = 'FETCH_STATISTICS_DEALERS_REQUEST';
export const FETCH_STATISTICS_DEALERS_SUCCESS = 'FETCH_STATISTICS_DEALERS_SUCCESS';
export const FETCH_STATISTICS_DEALERS_FAILURE = 'FETCH_STATISTICS_DEALERS_FAILURE';
export const FETCH_STATISTICS_ALL_DEALERS_REQUEST = 'STATS/SALES-AFTERSALES/DEALERS/FETCH_ALL_DEALERS_REQUEST';
export const FETCH_STATISTICS_ALL_DEALERS_SUCCESS = 'STATS/SALES-AFTERSALES/DEALERS/FETCH_ALL_DEALERS_SUCCESS';
export const FETCH_STATISTICS_ALL_DEALERS_FAILURE = 'STATS/SALES-AFTERSALES/DEALERS/FETCH_ALL_DEALERS_FAILURE';
export const FETCH_DEALERS_COUNTRIES_REQUEST = 'STATS/SALES-AFTERSALES/DEALERS/FETCH_COUNTRIES_REQUEST';
export const FETCH_DEALERS_COUNTRIES_FAILURE = 'STATS/SALES-AFTERSALES/DEALERS/FETCH_COUNTRIES_FAILURE';
export const FETCH_DEALERS_COUNTRIES_SUCCESS = 'STATS/SALES-AFTERSALES/DEALERS/FETCH_COUNTRIES_SUCCESS';

export const FETCH_STATISTICS_TIMELINE_STATUS_STATS_REQUEST = 'FETCH_STATISTICS_TIMELINE_STATUS_STATS_REQUEST';
export const FETCH_STATISTICS_TIMELINE_STATUS_STATS_SUCCESS = 'FETCH_STATISTICS_TIMELINE_STATUS_STATS_SUCCESS';
export const FETCH_STATISTICS_TIMELINE_STATUS_STATS_FAILURE = 'FETCH_STATISTICS_TIMELINE_STATUS_STATS_FAILURE';

export const FETCH_STATISTICS_INTERVENTION_BRANDS_REQUEST = 'FETCH_STATISTICS_INTERVENTION_BRANDS_REQUEST';
export const FETCH_STATISTICS_INTERVENTION_BRANDS_SUCCESS = 'FETCH_STATISTICS_INTERVENTION_BRANDS_SUCCESS';
export const FETCH_STATISTICS_INTERVENTION_BRANDS_FAILURE = 'FETCH_STATISTICS_INTERVENTION_BRANDS_FAILURE';

export const FETCH_STATISTICS_INTERVENTION_STATUS_STATS_REQUEST = 'FETCH_STATISTICS_INTERVENTION_STATUS_STATS_REQUEST';
export const FETCH_STATISTICS_INTERVENTION_STATUS_STATS_SUCCESS = 'FETCH_STATISTICS_INTERVENTION_STATUS_STATS_SUCCESS';
export const FETCH_STATISTICS_INTERVENTION_STATUS_STATS_FAILURE = 'FETCH_STATISTICS_INTERVENTION_STATUS_STATS_FAILURE';

export const FETCH_STATISTICS_INTERVENTION_RATING_STATS_REQUEST = 'FETCH_STATISTICS_INTERVENTION_RATING_STATS_REQUEST';
export const FETCH_STATISTICS_INTERVENTION_RATING_STATS_SUCCESS = 'FETCH_STATISTICS_INTERVENTION_RATING_STATS_SUCCESS';
export const FETCH_STATISTICS_INTERVENTION_RATING_STATS_FAILURE = 'FETCH_STATISTICS_INTERVENTION_RATING_STATS_FAILURE';

export const FETCH_STATISTICS_INTERVENTION_FOLLOW_UP_STATS_REQUEST = 'FETCH_STATISTICS_INTERVENTION_FOLLOW_UP_STATS_REQUEST';
export const FETCH_STATISTICS_INTERVENTION_FOLLOW_UP_STATS_SUCCESS = 'FETCH_STATISTICS_INTERVENTION_FOLLOW_UP_STATS_SUCCESS';
export const FETCH_STATISTICS_INTERVENTION_FOLLOW_UP_STATS_FAILURE = 'FETCH_STATISTICS_INTERVENTION_FOLLOW_UP_STATS_FAILURE';

export const FETCH_CUSTOMER_OPINION_STATS_REQUEST = 'FETCH_CUSTOMER_OPINION_STATS_REQUEST';
export const FETCH_CUSTOMER_OPINION_STATS_SUCCESS = 'FETCH_CUSTOMER_OPINION_STATS_SUCCESS';
export const FETCH_CUSTOMER_OPINION_STATS_FAILURE = 'FETCH_CUSTOMER_OPINION_STATS_FAILURE';

export const FETCH_STATISTICS_TOP_CONTRIBUTORS_REQUEST = 'FETCH_STATISTICS_TOP_CONTRIBUTORS_REQUEST';
export const FETCH_STATISTICS_TOP_CONTRIBUTORS_SUCCESS = 'FETCH_STATISTICS_TOP_CONTRIBUTORS_SUCCESS';
export const FETCH_STATISTICS_TOP_CONTRIBUTORS_FAILURE = 'FETCH_STATISTICS_TOP_CONTRIBUTORS_FAILURE';

export const FETCH_SELF_SERVICE_STATISTICS_TOP_CONTRIBUTORS_REQUEST = 'FETCH_SELF_SERVICE_STATISTICS_TOP_CONTRIBUTORS_REQUEST';
export const FETCH_SELF_SERVICE_STATISTICS_TOP_CONTRIBUTORS_SUCCESS = 'FETCH_SELF_SERVICE_STATISTICS_TOP_CONTRIBUTORS_SUCCESS';
export const FETCH_SELF_SERVICE_STATISTICS_TOP_CONTRIBUTORS_FAILURE = 'FETCH_SELF_SERVICE_STATISTICS_TOP_CONTRIBUTORS_FAILURE';

export const FETCH_STATISTICS_ANSWER_TIME_REQUEST = 'FETCH_STATISTICS_ANSWER_TIME_REQUEST';
export const FETCH_STATISTICS_ANSWER_TIME_SUCCESS = 'FETCH_STATISTICS_ANSWER_TIME_SUCCESS';
export const FETCH_STATISTICS_ANSWER_TIME_FAILURE = 'FETCH_STATISTICS_ANSWER_TIME_FAILURE';

export const FETCH_STATISTICS_INTERVENTION_COUNT_REQUEST = 'FETCH_STATISTICS_INTERVENTION_COUNT_REQUEST';
export const FETCH_STATISTICS_INTERVENTION_COUNT_SUCCESS = 'FETCH_STATISTICS_INTERVENTION_COUNT_SUCCESS';
export const FETCH_STATISTICS_INTERVENTION_COUNT_FAILURE = 'FETCH_STATISTICS_INTERVENTION_COUNT_FAILURE';

export const FETCH_STATISTICS_REVENUE_STATS_REQUEST = 'FETCH_STATISTICS_REVENUE_STATS_REQUEST';
export const FETCH_STATISTICS_REVENUE_STATS_SUCCESS = 'FETCH_STATISTICS_REVENUE_STATS_SUCCESS';
export const FETCH_STATISTICS_REVENUE_STATS_FAILURE = 'FETCH_STATISTICS_REVENUE_STATS_FAILURE';

export const FETCH_STATISTICS_REVENUE_BY_BRAND_STATS_REQUEST = 'FETCH_STATISTICS_REVENUE_BY_BRAND_STATS_REQUEST';
export const FETCH_STATISTICS_REVENUE_BY_BRAND_STATS_FAILURE = 'FETCH_STATISTICS_REVENUE_BY_BRAND_STATS_FAILURE';
export const FETCH_STATISTICS_REVENUE_BY_BRAND_STATS_SUCCESS = 'FETCH_STATISTICS_REVENUE_BY_BRAND_STATS_SUCCESS';

export const FETCH_STATISTICS_REVENUE_BY_PERIOD_STATS_REQUEST = 'FETCH_STATISTICS_REVENUE_BY_PERIOD_STATS_REQUEST';
export const FETCH_STATISTICS_REVENUE_BY_PERIOD_STATS_FAILURE = 'FETCH_STATISTICS_REVENUE_BY_PERIOD_STATS_FAILURE';
export const FETCH_STATISTICS_REVENUE_BY_PERIOD_STATS_SUCCESS = 'FETCH_STATISTICS_REVENUE_BY_PERIOD_STATS_SUCCESS';

export const SET_DEALER_STATISTICS_PERIOD = 'SET_DEALER_STATISTICS_PERIOD';
export const SET_AUDIT_STATISTICS_PERIOD = 'SET_AUDIT_STATISTICS_PERIOD';

export const SET_DEALER_STATISTICS_FILTERS = 'SET_DEALER_STATISTICS_FILTERS';
export const STATISTICS_DEALER_DETAILS_READY = 'DEALER/STATISTICS/DETAILS/READY';
export const STATISTICS_DEALER_EXPORT_MODAL_VISIBILITY = 'DEALER/STATISTICS/EXPORT_VISIBILITY';

export const STATISTICS_DEALER_EXPORT = 'DEALER/STATISTICS/EXPORT_REQUEST';
export const STATISTICS_DEALER_EXPORT_SUCCESS = 'DEALER/STATISTICS/EXPORT_SUCCESS';
export const STATISTICS_DEALER_EXPORT_FAILURE = 'DEALER/STATISTICS/EXPORT_FAILURE';

/* AUDIT STATISTICS */
export const FETCH_AUDIT_STATISTICS_REQUEST = 'FETCH_AUDIT_STATISTICS_REQUEST';
export const FETCH_AUDIT_STATISTICS_DONE = 'FETCH_AUDIT_STATISTICS_DONE';
export const FETCH_AUDIT_STATISTICS_SUCCESS = 'FETCH_AUDIT_STATISTICS_SUCCESS';
export const FETCH_AUDIT_STATISTICS_FAILURE = 'FETCH_AUDIT_STATISTICS_FAILURE';
export const FETCH_AUDIT_STATISTICS_COUNT_REQUEST = 'FETCH_AUDIT_STATISTICS_COUNT_REQUEST';
export const FETCH_AUDIT_STATISTICS_COUNT_SUCCESS = 'FETCH_AUDIT_STATISTICS_COUNT_SUCCESS';
export const FETCH_AUDIT_STATISTICS_COUNT_FAILURE = 'FETCH_AUDIT_STATISTICS_COUNT_FAILURE';
export const FETCH_AUDIT_STATISTICS_AVG_TIME_REQUEST = 'STATISTICS/AUDITS/AVG_TIME_REQUEST';
export const FETCH_AUDIT_STATISTICS_AVG_TIME_SUCCESS = 'STATISTICS/AUDITS/AVG_TIME_SUCCESS';
export const FETCH_AUDIT_STATISTICS_AVG_TIME_FAILURE = 'STATISTICS/AUDITS/AVG_TIME_FAILURE';
export const FETCH_AUDIT_STATISTICS_AUDITS_REQUEST = 'FETCH_AUDIT_STATISTICS_AUDITS_REQUEST';
export const FETCH_AUDIT_STATISTICS_AUDITS_SUCCESS = 'FETCH_AUDIT_STATISTICS_AUDITS_SUCCESS';
export const FETCH_AUDIT_STATISTICS_AUDITS_FAILURE = 'FETCH_AUDIT_STATISTICS_AUDITS_FAILURE';

export const AUDIT_STATISTICS_ADD_FILTER = 'AUDIT_STATISTICS_ADD_FILTER';
export const AUDIT_STATISTICS_REMOVE_FILTER = 'AUDIT_STATISTICS_REMOVE_FILTER';
export const AUDIT_STATISTICS_REMOVE_FILTERS = 'AUDIT_STATISTICS_REMOVE_FILTERS';
export const CLEAR_AUDIT_STATISTICS = 'CLEAR_AUDIT_STATISTICS';
export const CLEAR_AUDIT_STATISTIC = 'CLEAR_AUDIT_STATISTIC';
export const CLEAR_AUDIT_STATISTICS_AUDITS = 'CLEAR_AUDIT_STATISTICS_AUDITS';

/* CHECK LIST ADVICE STATS */
export const FETCH_CATEGORIES_STATS_DISTRIBUTION_REQUEST = 'FETCH_CATEGORIES_STATS_DISTRIBUTION_REQUEST';
export const FETCH_CATEGORIES_STATS_DISTRIBUTION_SUCCESS = 'FETCH_CATEGORIES_STATS_DISTRIBUTION_SUCCESS';
export const FETCH_CATEGORIES_STATS_DISTRIBUTION_FAILURE = 'FETCH_CATEGORIES_STATS_DISTRIBUTION_FAILURE';

export const FETCH_CATEGORIES_STATS_REVENUE_REQUEST = 'FETCH_CATEGORIES_STATS_REVENUE_REQUEST';
export const FETCH_CATEGORIES_STATS_REVENUE_SUCCESS = 'FETCH_CATEGORIES_STATS_REVENUE_SUCCESS';
export const FETCH_CATEGORIES_STATS_REVENUE_FAILURE = 'FETCH_CATEGORIES_STATS_REVENUE_FAILURE';

export const ADD_FILTERS_CATEGORIES_STATS_REVENUE = 'ADD_FILTERS_CATEGORIES_STATS_REVENUE';

export const FETCH_CATEGORIES_STATS_CONTRIBUTOR_REQUEST = 'FETCH_CATEGORIES_STATS_CONTRIBUTOR_REQUEST';
export const FETCH_CATEGORIES_STATS_CONTRIBUTOR_SUCCESS = 'FETCH_CATEGORIES_STATS_CONTRIBUTOR_SUCCESS';
export const FETCH_CATEGORIES_STATS_CONTRIBUTOR_FAILURE = 'FETCH_CATEGORIES_STATS_CONTRIBUTOR_FAILURE';

export const FETCH_STATISTICS_SEVERITY = 'STATISTIC/SEVERITY/REQUEST';
export const FETCH_STATISTICS_SEVERITY_SUCCESS = 'STATISTIC/SEVERITY/SUCCESS';
export const FETCH_STATISTICS_SEVERITY_FAILURE = 'STATISTIC/SEVERITY/FAILURE';

export const FETCH_STATISTICS_TOP_ANYTHING = 'STATISTIC/TOP_ANYTHING/REQUEST';
export const FETCH_STATISTICS_TOP_ANYTHING_SUCCESS = 'STATISTIC/TOP_ANYTHING/SUCCESS';
export const FETCH_STATISTICS_TOP_ANYTHING_FAILURE = 'STATISTIC/TOP_ANYTHING/FAILURE';

export const FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_AUTHOR_REQUEST =
  'FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_AUTHOR_REQUEST';
export const FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_AUTHOR_SUCCESS =
  'FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_AUTHOR_SUCCESS';
export const FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_AUTHOR_FAILURE =
  'FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_AUTHOR_FAILURE';
export const FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_SENDER_REQUEST =
  'FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_SENDER_REQUEST';
export const FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_SENDER_SUCCESS =
  'FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_SENDER_SUCCESS';
export const FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_SENDER_FAILURE =
  'FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_SENDER_FAILURE';

/* MODELS */
export const FETCH_MODELS_REQUEST = 'FETCH_MODELS_REQUEST';
export const FETCH_MODELS_SUCCESS = 'FETCH_MODELS_SUCCESS';
export const FETCH_MODELS_FAILURE = 'FETCH_MODELS_FAILURE';

export const FETCH_MODELS_SELECT_REQUEST = 'FETCH_MODELS_SELECT_REQUEST';
export const FETCH_MODELS_SELECT_NEXT_PAGE_REQUEST = 'FETCH_MODELS_SELECT_NEXT_PAGE_REQUEST';
export const FETCH_MODELS_SELECT_SUCCESS = 'FETCH_MODELS_SELECT_SUCCESS';
export const FETCH_MODELS_SELECT_FAILURE = 'FETCH_MODELS_SELECT_FAILURE';
export const CLEAN_MODELS_SELECT = 'CLEAN_MODELS_SELECT';
export const TOGGLE_VALID_MODELS = 'TOGGLE_VALID_MODELS';

export const UPLOAD_MODEL_REQUEST = 'UPLOAD_MODEL_REQUEST';
export const UPLOAD_MODELS_REQUEST = 'UPLOAD_MODELS_REQUEST';
export const UPLOAD_MODELS_SUCCESS = 'UPLOAD_MODELS_SUCCESS';
export const UPLOAD_MODELS_FAILURE = 'UPLOAD_MODELS_FAILURE';

export const UPDATE_MODEL_REQUEST = 'UPDATE_MODEL_REQUEST';
export const UPDATE_MODEL_SUCCESS = 'UPDATE_MODEL_SUCCESS';
export const UPDATE_MODEL_FAILURE = 'UPDATE_MODEL_FAILURE';

export const FETCH_MODEL_REQUEST = 'FETCH_MODEL_REQUEST';
export const FETCH_MODEL_SUCCESS = 'FETCH_MODEL_SUCCESS';
export const FETCH_MODEL_FAILURE = 'FETCH_MODEL_FAILURE';

export const SET_MODEL_FILTER = 'SET_MODEL_FILTER';
export const CLEAN_MODEL_FILTER = 'CLEAN_MODEL_FILTER';
export const CLEAN_MODELS_DASHBOARD = 'CLEAN_MODELS_DASHBOARD';

// NEW OFFER
export const CHANGE_OFFER = 'CHANGE_OFFER';
export const RESET_NEW_OFFER = 'RESET_NEW_OFFER';
export const SET_CATEGORY_AS_SEEN = 'SET_CATEGORY_AS_SEEN';

/* OFFERS */
export const COPY_OFFER_REQUEST = 'COPY_OFFER_REQUEST';
export const COPY_OFFER_SUCCESS = 'COPY_OFFER_SUCCESS';
export const COPY_OFFER_FAILURE = 'COPY_OFFER_FAILURE';

export const DELETE_OFFER_REQUEST = 'DELETE_OFFER_REQUEST';
export const DELETE_OFFER_SUCCESS = 'DELETE_OFFER_SUCCESS';
export const DELETE_OFFER_FAILURE = 'DELETE_OFFER_FAILURE';

export const EXPORT_OFFERS_REQUEST = 'EXPORT_OFFERS_REQUEST';
export const EXPORT_OFFERS_SUCCESS = 'EXPORT_OFFERS_SUCCESS';
export const EXPORT_OFFERS_FAILURE = 'EXPORT_OFFERS_FAILURE';

export const FETCH_OFFER_REQUEST = 'FETCH_OFFER_REQUEST';
export const FETCH_OFFER_SUCCESS = 'FETCH_OFFER_SUCCESS';
export const FETCH_OFFER_FAILURE = 'FETCH_OFFER_FAILURE';

export const FETCH_OFFERS_REQUEST = 'FETCH_OFFERS_REQUEST';
export const FETCH_OFFERS_SUCCESS = 'FETCH_OFFERS_SUCCESS';
export const FETCH_OFFERS_FAILURE = 'FETCH_OFFERS_FAILURE';

export const FETCH_OFFER_SPECS_PDF_REQUEST = 'FETCH_OFFER_SPECS_PDF_REQUEST';
export const FETCH_OFFER_SPECS_PDF_SUCCESS = 'FETCH_OFFER_SPECS_PDF_SUCCESS';
export const FETCH_OFFER_SPECS_PDF_FAILURE = 'FETCH_OFFER_SPECS_PDF_FAILURE';

export const SAVE_OFFER_REQUEST = 'SAVE_OFFER_REQUEST';
export const SAVE_OFFER_SUCCESS = 'SAVE_OFFER_SUCCESS';
export const SAVE_OFFER_FAILURE = 'SAVE_OFFER_FAILURE';

export const SELECT_OFFER = 'SELECT_OFFER';
export const CLEAN_OFFERS = 'CLEAN_OFFERS';

export const DISPLAY_SETTINGS_MODAL = 'DISPLAY_SETTINGS_MODAL';
export const HIDE_SETTINGS_MODAL = 'HIDE_SETTINGS_MODAL';
export const DISPLAY_CUSTOMER_CREATION = 'DISPLAY_CUSTOMER_CREATION';
export const HIDE_CUSTOMER_CREATION = 'HIDE_CUSTOMER_CREATION';

export const SET_OFFER_MODAL_VALUE = 'SET_OFFER_MODAL_VALUE';

export const DISPLAY_CONSENT_MODAL = 'DISPLAY_CONSENT_MODAL';
export const HIDE_CONSENT_MODAL = 'HIDE_CONSENT_MODAL';
export const CONSENT_OFFER = 'CONSENT_OFFER';
export const POST_INTERVENTION_OFFER = 'CONFIGURATOR/OFFER/CREATE_INTERVENTION';
export const POST_INTERVENTION_OFFER_SUCCESS = 'CONFIGURATOR/OFFER/CREATE_INTERVENTION_SUCCESS';
export const POST_INTERVENTION_OFFER_FAILURE = 'CONFIGURATOR/OFFER/CREATE_INTERVENTION_FAILURE';

// DERIVATIVES
export const FETCH_DERIVATIVE_REQUEST = 'FETCH_DERIVATIVE_REQUEST';
export const FETCH_DERIVATIVE_SUCCESS = 'FETCH_DERIVATIVE_SUCCESS';
export const FETCH_DERIVATIVE_FAILURE = 'FETCH_DERIVATIVE_FAILURE';

// TVA VALUES
export const FETCH_TVA_VALUES_REQUEST = 'FETCH_TVA_VALUES_REQUEST';
export const FETCH_TVA_VALUES_SUCCESS = 'FETCH_TVA_VALUES_SUCCESS';
export const FETCH_TVA_VALUES_FAILURE = 'FETCH_TVA_VALUES_FAILURE';

// VARIANTS
export const FETCH_VARIANT_REQUEST = 'FETCH_VARIANT_REQUEST';
export const FETCH_VARIANT_SUCCESS = 'FETCH_VARIANT_SUCCESS';
export const FETCH_VARIANT_FAILURE = 'FETCH_VARIANT_FAILURE';
export const FETCH_VARIANT_MUTEX_REQUEST = 'FETCH_VARIANT_MUTEX_REQUEST';
export const FETCH_VARIANT_MUTEX_SUCCESS = 'FETCH_VARIANT_MUTEX_SUCCESS';
export const FETCH_VARIANT_MUTEX_FAILURE = 'FETCH_VARIANT_MUTEX_FAILURE';
export const CLEAN_VARIANT = 'CLEAN_VARIANT';

export const OPEN_UPDATE_MODAL = 'OPEN_UPDATE_MODAL';
export const CLOSE_UPDATE_MODAL = 'CLOSE_UPDATE_MODAL';

export const USER_DETAILS_PAGE_IS_READY = 'USER/DETAILS/READY';
